
//获取cookie
function getCookie(name){
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name){
            return arr[1];
        }
    }
    return "";
}
//获取URL的值
function getParams() {
    let hrefStr = window.location.href;
    let paramObj = {};
    if (hrefStr.indexOf("?") > -1) {
        let paramArr = hrefStr.split("?")[1].split("&");
        for (let i = 0; i < paramArr.length; i++) {
            paramObj[paramArr[i].split("=")[0]] = paramArr[i].split("=")[1];
        }
    }
    return paramObj;
}
//获取查询框是否有值
function getQueryObj(obj){
    if (!obj)return false;
    for(let k in obj){
        if(k != "pageSize" && k != "pageNum" && k != "send" && k != "send1" && k != "orderBy" && obj[k])return true;
    }
    return false;
}
function judge(arr,obj){
    let flag = 0;
    if(arr.length != 0){ //勾选
        return flag = 1;
    }else{
        if(getQueryObj(obj)){ //条件筛选
            return flag = 2;
        }
    }
    return flag;
}
//
function getQueryVal(obj){
    let params = {};
    if (!obj)return false;
    for(let k in obj){
        if(k != "send" && k != "send1" && k != "orderBy" && k != "deptArr" && k != 'departmentArr' ){
            if(obj[k] || obj[k] === 0){
                params[k] = obj[k];
            }
        }
    }
    return params;
}
//排序
function arrs(obj){
    obj.sort(function (m, n) {
        if (m < n) return -1
        else if (m > n) return 1
        else return 0
    });
}
function TimeChange(val){
    let params=[];
    if(val){
        params[0]= val[0];
        params[1]= val[1];
    }else{
        params[0]= '';
        params[1]= '';
    }
    return params;
}
//金额改为标准的保留两位小数
function HandleData(val){
    let a = val.toString().lastIndexOf('.');
    let b=  val.toString().length - 1
    if(a == -1){
        return (val=val+'.00');
    }else if((a != -1) && (b - a == 2)){
        return (val);
    }else if((a != -1) && (b - a == 1)){
        return (val = val+'0');
    }else{
        return (val); 
    }
}
//处理排序的字段
function sortOpe(prop, order){
    let orderBy = '';
    if(order == 'descending'){
        orderBy = prop + ' desc';
    }else{
        orderBy = prop + ' asc';
    }
    return orderBy;
}
// js计算不精准的
// 加法：
function dcmAdd(arg1,arg2){
    var r1,r2,m; 
    try{r1=arg1.toString().split(".")[1].length;}catch(e){r1=0;}
    try{r2=arg2.toString().split(".")[1].length;}catch(e){r2=0;}
    m=Math.pow(10,Math.max(r1,r2));
    return (accMul(arg1,m)+accMul(arg2,m))/m;
}
// 减法：
function dcmsub(arg1,arg2){
    var r1,r2,m; 
    try{r1=arg1.toString().split(".")[1].length;}catch(e){r1=0;}
    try{r2=arg2.toString().split(".")[1].length;}catch(e){r2=0;}
    m=Math.pow(10,Math.max(r1,r2));
    return (accMul(arg1,m)-accMul(arg2,m))/m;
}
// 乘法：
function accMul(arg1,arg2){
    var m=0,s1=arg1.toString(),s2=arg2.toString();
    try{m+=s1.split(".")[1].length}catch(e){}
    try{m+=s2.split(".")[1].length}catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
}
function numberFormat(n, c, d, t){
    var c = isNaN(c = Math.abs(c)) ? 2 : c, 
        d = d == undefined ? "." : d, 
        t = t == undefined ? "," : t, 
        s = n < 0 ? "-" : "", 
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
        j = (j = i.length) > 3 ? j % 3 : 0;
       return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};
//今日是否为当月的最后一天
function isLastDayOfMonth() {
    var flag = false;
    var date = new Date();

    var year = date.getFullYear();
    var month = date.getMonth()+1;
    var today = date.getDate();

    var new_year = year; //取当前的年份
    var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）
    if(month>12){//如果当前大于12月，则年份转到下一年
        new_month -=12; //月份减
        new_year++; //年份增
    }
    var new_date = new Date(new_year,new_month,1); //取当年当月中的第一天

    var month_last_day = (new Date(new_date.getTime()-1000*60*60*24)).getDate();
    if(today == month_last_day){
        flag = true;
    }
    return flag;
}
//获取年月日时分秒毫秒+4位随机数
function getCurDate(){
    let date = new Date();
    // 获取年份
    let year = String(date.getFullYear());
    // 获取月份，月份从0开始，需要加1
    let month = String(date.getMonth() + 1);
    month = month > 9 ? month : '0'+ month;
    // 获取日期
    let day = String(date.getDate());
    day = day > 9 ? day : '0'+ day;
    // 获取小时
    let hours = String(date.getHours());
    hours = hours > 9 ? hours : '0'+ hours;
    // 获取分钟
    let minutes = String(date.getMinutes());
    minutes = minutes > 9 ? minutes : '0'+ minutes;
    // 获取秒数
    let seconds = String(date.getSeconds());
    seconds = seconds > 9 ? seconds : '0'+ seconds;
    //毫秒
    let milliseconds = String(date.getMilliseconds()); 
    if(milliseconds < 10){
        milliseconds = '00'+ milliseconds
    }else if(milliseconds < 100){
        milliseconds = '0'+ milliseconds
    }
    //获取0-9999 的随机数
    let randomNum = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    return year + month + day + hours + minutes + seconds + milliseconds + randomNum;
}
/**
 * 判断操作系统
 */
function detectOS() {
    const isMac =
        navigator.platform === 'Mac68K' ||
        navigator.platform === 'MacPPC' ||
        navigator.platform === 'Macintosh' ||
        navigator.platform === 'MacIntel';

    if(navigator.platform === 'Win32' || navigator.platform === 'Windows'){
        return 'Windows'
    }else if(isMac){
        return 'Mac'
    }else if(String(navigator.platform).indexOf('Linux') > -1){
        return 'Linux'
    }else if(navigator.platform === 'X11' && !isWin && !isMac){
        return 'Unix'
    }else{
        return 'Unknown'
    }
}

/**
 * 将数字转换为带单位的格式，例如将120000000转成1.2亿
 * @param {number} num - 需要转换的数字
 * @param {number} decNum - 保留的小数位数，默认为2
 * @return {string} - 格式化后的数字字符串
 */
function formatNumberUnit(num, decNum = 2) {
    if (typeof num !== 'number' || isNaN(num)) {
        return num;
    }

    let result = '';
    decNum = decNum < 0 ? 0 : decNum;
    decNum = decNum > 10 ? 10 : decNum;

    if (Math.abs(num) < 10000) {
        // 小于1万，直接显示
        result = num.toFixed(decNum);
    } else if (Math.abs(num) < 100000000) {
        // 1万到1亿之间，以万为单位
        result = (num / 10000).toFixed(decNum) + '万';
    } else {
        // 大于等于1亿，以亿为单位
        result = (num / 100000000).toFixed(decNum) + '亿';
    }

    // 移除末尾多余的0和小数点
    if (result.indexOf('.') > -1) {
        result = result.replace(/\.?0+$/, '');
    }

    return result;
}

/**
 * 拆分数字和单位，例如将"1.2亿"拆分成["1.2", "亿"]
 * @param {string} str - 需要拆分的字符串，如"1.2亿"、"3.5万"等
 * @return {Array} - 返回包含数字和单位的数组，如["1.2", "亿"]
 */
function splitNumberAndUnit(str) {
    if (typeof str !== 'string' || !str) {
        return ['', ''];
    }
    
    // 使用正则表达式匹配数字和单位
    const regex = /^([\d.]+)([^\d]+)$/;
    const match = str.match(regex);
    
    if (match) {
        return [match[1], match[2]];
    } else {
        // 如果不匹配标准格式，尝试使用更通用的方法
        let numPart = '';
        let unitPart = '';
        
        for (let i = 0; i < str.length; i++) {
            if (/[0-9.]/.test(str[i])) {
                numPart += str[i];
            } else {
                // 找到第一个非数字字符后，后面的所有字符都属于单位部分
                unitPart = str.substring(i);
                break;
            }
        }
        
        return [numPart, unitPart];
    }
}

/**
 * 将字符串转换为数字类型
 * @param {string} str - 需要转换的字符串，如'888.00'
 * @return {number} - 返回转换后的数字
 */
function stringToNumber(str) {
    if (typeof str !== 'string' && typeof str !== 'number') {
        return NaN;
    }
    
    // 使用parseFloat转换为数字
    const result = parseFloat(str);
    
    // 检查转换结果是否为有效数字
    return isNaN(result) ? NaN : result;
}
// 转大写
function convertCurrency(money) {
        //汉字的数字
        var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
        //基本单位
        var cnIntRadice = new Array('', '拾', '佰', '仟');
        //对应整数部分扩展单位
        var cnIntUnits = new Array('', '万', '亿', '兆');
        //对应小数部分单位
        var cnDecUnits = new Array('角', '分', '毫', '厘');
        //整数金额时后面跟的字符
        var cnInteger = '整';
        //整型完以后的单位
        var cnIntLast = '元';
        //最大处理的数字
        var maxNum = 999999999999999.9999;
        //金额整数部分
        var integerNum;
        //金额小数部分
        var decimalNum;
        //输出的中文金额字符串
        var chineseStr = '';
        //分离金额后用的数组，预定义
        var parts;
        if (money == '') { return ''; }
        money = parseFloat(money);
        if (money >= maxNum) {
            //超出最大处理数字
            return '';
        }
        if (money == 0) {
            chineseStr = cnNums[0] + cnIntLast + cnInteger;
            return chineseStr;
        }
        //转换为字符串
        money = money.toString();
        if (money.indexOf('.') == -1) {
            integerNum = money;
            decimalNum = '';
        } else {
            parts = money.split('.');
            integerNum = parts[0];
            decimalNum = parts[1].substr(0, 4);
        }
        //获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
            var zeroCount = 0;
            var IntLen = integerNum.length;
            for (var i = 0; i < IntLen; i++) {
                var n = integerNum.substr(i, 1);
                var p = IntLen - i - 1;
                var q = p / 4;
                var m = p % 4;
                if (n == '0') {
                    zeroCount++;
                } else {
                    if (zeroCount > 0) {
                        chineseStr += cnNums[0];
                    }
                    //归零
                    zeroCount = 0;
                    chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                }
                if (m == 0 && zeroCount < 4) {
                    chineseStr += cnIntUnits[q];
                }
            }
            chineseStr += cnIntLast;
        }
        //小数部分
        if (decimalNum != '') {
            var decLen = decimalNum.length;
            for (var i = 0; i < decLen; i++) {
                var n = decimalNum.substr(i, 1);
                if (n != '0') {
                    chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                }
            }
        }
        if (chineseStr == '') {
            chineseStr += cnNums[0] + cnIntLast + cnInteger;
        } else if (decimalNum == '') {
            chineseStr += cnInteger;
        }
        return chineseStr;
    }

export default {
    getCookie:function(name){
        return getCookie(name)
    },
    getQueryObj:function(obj){
        return getQueryObj(obj)
    },
    judge:function(arr,obj){
        return judge(arr,obj)
    },
    arrs:function(obj){
        return arrs(obj)
    },
    getParams:function(){
        return getParams()
    },
    TimeChange:function(val,obj,obj1,obj2){
        return TimeChange(val,obj,obj1,obj2)
    },
    numberFormat:function(n,c,d,t){
        return numberFormat(n,c,d,t)
    },
    HandleData:function(val){
        return HandleData(val)
    },
    sortOpe:function( prop, order){
        return sortOpe(prop, order)
    },
    dcmAdd(arg1,arg2){
        return dcmAdd(arg1,arg2)
    },
    dcmsub(arg1,arg2){
        return dcmsub(arg1,arg2)
    },
    accMul(arg1,arg2){
        return accMul(arg1,arg2)
    },
    isLastDayOfMonth(){
        return isLastDayOfMonth()
    },
    getQueryVal(obj){
        return getQueryVal(obj)
    },
    detectOS(){
        return detectOS();
    },
    getCurDate(){
        return getCurDate();
    },
    formatNumberUnit(num, decNum){
        return formatNumberUnit(num, decNum)
    },
    getLastChar(str){
        return getLastChar(str)
    },
    splitNumberAndUnit(str){
        return splitNumberAndUnit(str)
    },
    stringToNumber(str){
        return stringToNumber(str)
    },
    convertCurrency(money){
        return convertCurrency(money)
    }
}


// WEBPACK FOOTER //
// ./src/assets/script/common.js